import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import store from './Services/store'
import axios from 'axios'
Vue.use(Router)

let router = new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/',
          name: 'dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard.vue'),
          meta: { 
            requireAuth: true
        }
        },
        {
          path: '/events/add',
          name: 'AddEvent',
          component: () => import(/* webpackChunkName: "demo" */ './views/Events/AddEvent.vue'),
          props: true,
          meta: { 
            requireAuth: true
        }
        },
        {
          path: '/events/edit/:jobid',
          name: 'EditEvent',
          component: () => import(/* webpackChunkName: "demo" */ './views/Events/EditEvent.vue'),
          meta: { 
            requireAuth: true
        }
        },
        {
          path: '/events/detail/:jobid',
          name: 'DetailEvent',
          component: () => import(/* webpackChunkName: "demo" */ './views/Events/Detail.vue'),
          meta: { 
            requireAuth: true
        }
        },
        {
          path: '/events/history',
          name: 'events/history',
          component: () => import(/* webpackChunkName: "demo" */ './views/Events/History.vue'),
          meta: { 
            requireAuth: true
        }
        },
        {
          path: '/events',
          name: 'events',
          component: () => import(/* webpackChunkName: "demo" */ './views/Events/Events.vue'),
          meta: { 
            requireAuth: true
        }
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "demo" */ './views/UserProfile.vue'),
          meta: { 
            requireAuth: true
        }
        },
        {
          path: '/tables',
          name: 'tables',
          component: () => import(/* webpackChunkName: "demo" */ './views/Tables.vue'),
          meta: { 
            requireAuth: true
        }
        },
        {
          path: '/organizations',
          name: 'organizations',
          component: () => import('./views/organiztions/Organizations.vue'),
          meta: { 
            requireAuth: true
        }
        },
        {
          path: '/organizations/create',
          name: 'createorg',
          component: () => import('./views/organiztions/AddOrg.vue'),
          meta: { 
            requireAuth: true
        }
        },
        {
          path: '/organizations/edit/:orgid',
          name: 'editorg',
          component: () => import('./views/organiztions/EditOrg.vue'),
          props: true,
          meta: { 
            requireAuth: true
        }
        } ,
        {
          path: '/organizations/detail/:orgid/create',
          name: 'createtenantfororg',
          component: () => import('./views/organiztions/AddTenant.vue'),
          meta: { 
            requireAuth: true
        }
        },
        {
          path: '/organizations/detail/:orgid',
          name: 'detailorg',
          component: () => import('./views/organiztions/DetailOrg.vue'),
          props: true,
          meta: { 
            requireAuth: true
        }
        } ,
        {
          path: '/tenants',
          name: 'tenants',
          component: () => import('./views/Tenants/Tenants.vue'),
          meta: { 
            requireAuth: true
        }
        },
        {
          path: '/tenants/create',
          name: 'createtenant',
          component: () => import('./views/Tenants/AddTenant.vue'),
          meta: { 
            requireAuth: true
        }
            
        },
        {
          path: '/tenants/edit/:tenantid',
          name: 'edittenant',
          component: () => import('./views/Tenants/EditTenant.vue'),
          props: true,
          meta: { 
            requireAuth: true
        }
        },
        {
          path: '/management/canon',
          name: 'canon',
          component: () => import('./views/Managements/Canon.vue'),
          meta: { 
            requireAdmin: true
        }
        },
        {
          path: '/management/users',
          name: 'users',
          component: () => import('./views/Managements/Users.vue'),
          meta: { 
            requireAdmin: true
        }
        },
        {
          path: '/management/report',
          name: 'report',
          component: () => import('./views/Managements/Report.vue'),
          meta: { 
            requireAdmin: true
        }
        },
        {
          path: '/tools/board',
          name: 'board',
          component:()=> import('./views/Managements/Board.vue'),
          meta: { 
            requireAuth: true
          },
          
        },
        {
          path: '/tools/nwdevice',
          name: 'nwdevice',
          component:()=> import('./views/Network/Device.vue'),
          meta: { 
            requireAuth: true
          }
        }
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "demo" */ './views/Login.vue'),
          meta: { 
            guest: true
        }
        }
      ]
    }
  ]

})

router.beforeEach(async(to,from,next)=> {
  if(to.matched.some(record => record.meta.requireAuth)) {
    if (store.getters.isAuthenticated) {
      if(Object.keys(store.state.user).length === 0) {
        axios.defaults.headers.common['Authorization'] = 'jwt '+ store.state.token
        let res = await axios.get('http://222.255.100.41:3000/users/detail')
        localStorage.setItem('user', res.data)
        await store.dispatch('update_user', res.data)
      } 
      next()
      return
    }
    next('/login') 
  } 
  else if(to.matched.some(record => record.meta.requireAdmin)) {
    if( store.getters.is_admin) {
      next()
      return
    }
    next('/')
  }
  else {
    next() 
  }
})
export default router